
// #region imports

// #region vue
import { Component, Prop, Vue } from 'vue-property-decorator'
// #endregion

// #region interfaces
import { SurveyInterface } from '@/types/interfaces/survey'
// #endregion

// #endregion

@Component
export default class SurveyStatus extends Vue {
  @Prop({ required: true }) readonly item!: SurveyInterface[]
}
